// extracted by mini-css-extract-plugin
export default {"page-results":"PageResults_page-results__QXSkb","section-results":"PageResults_section-results__AR5qR"};